import {
    type ViewStyle,
    StyleSheet
} from "react-native";
import type {
    QuestionnaireChoicesDynamicStyleType
} from "./type";
import type {
    Mutable
} from "../../../../types";

const stylesheet = StyleSheet.create({
    container: {
        flexDirection: "column",
        minWidth: 0
    }
});

export const useStyles = ({
    spaces
}: QuestionnaireChoicesDynamicStyleType) => {
    const styles = {
        container: {
            gap: spaces.spacingSm
        } as Mutable<ViewStyle>
    };

    return styles;
};
export default stylesheet;
